import { Dialog } from '@factorialco/f0-react/dist/experimental'
import { Check } from '@factorialco/f0-react/icons/app'
import {
  AtsVacanciesActivateVacanciesDocument,
  AtsVacanciesTableDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  vacancyIds: string[]
  onClose: () => void
  onSuccess: () => void
}

export const ActivateVacanciesDialog = ({ vacancyIds, onClose, onSuccess }: Props) => {
  const [activateVacancies, { loading, client }] = useMutation(
    AtsVacanciesActivateVacanciesDocument,
    {
      extractorFn: (result) => result.atsMutations.bulkReopenAtsVacancy,
    }
  )

  const handleActivate = async () => {
    const result = await activateVacancies({
      variables: {
        ids: vacancyIds,
      },
    })

    const handled = handleResult(result, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('ats.vacancies.activate_vacancy_dialog.error_message'),
      })
    })

    if (handled.success) {
      void client.refetchQueries({ include: [AtsVacanciesTableDocument] })

      app.setFlash({
        type: 'correct',
        message: i18n.t('ats.vacancies.activate_vacancy_dialog.success_message'),
      })
      onSuccess()
    }
  }

  return (
    <Dialog
      open
      onClose={onClose}
      header={{
        type: 'info',
        title: i18n.t('ats.vacancies.activate_vacancy_dialog.title'),
        description: i18n.t('ats.vacancies.activate_vacancy_dialog.description'),
      }}
      actions={{
        primary: {
          icon: Check,
          label: i18n.t('ats.vacancies.activate_vacancy_dialog.confirm_button'),
          onClick: handleActivate,
          disabled: loading,
        },
        secondary: {
          label: i18n.t('common.cancel'),
          onClick: onClose,
        },
      }}
    />
  )
}
